import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationLocationTpamsConstants {
    static STEP_TITLE = "Location";
    static ZONE_LABEL = "Current property zoning";
    static ADD_ZONE_LABEL = "Add zone";
    static MISSING_ZONE_LABEL = "Missing zone(s):";
    static MISSING_ZONE_LABEL_EMAIL = " - Email sent to Administrator";
    static MISSING_ZONE_LABEL_EMAIL_FAILED = "Failed to send missing lookups for zones email to module administrator";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static COPY_OWNER_LABEL = "Copy owner to applicant";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property you are lodging an application for by using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property.  Note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "The zoning here is the current zoning of the property and an owner should be added for each property (this is linked to the property and the application).";
    static PROPERTY_REQUIRED = "Please select a property before continuing with the create application process";
    static MISSING_ZONE_EMAIL_SUBJECT = "Missing property zone(s) - add to lookups";
    static MISSING_ZONE_EMAIL_CONTENT = "Please add the following property zone(s) to the lookups:";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static BUILDING_USE_CONTROL = "buildingUse";
    static ERF_SIZE_CONTROL = "erfSize";
    static BUILDING_FLOOR_AREA_CONTROL = "buildingFloorArea";
    static TITLE_DEED_CONTROL = "titleDeed";
    static ZONE_CONTROL = "zone";
    static OWNER_CONTROL = "owners";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static BUILDING_USE_TEXT_PLACEHOLDER = "Building use";
    static ERF_SIZE_TEXT_PLACEHOLDER = "Erf size (m2)";
    static BUILDING_FLOOR_AREA_TEXT_PLACEHOLDER = "Building floor area (m2)";
    static TITLE_DEED_TEXT_PLACEHOLDER = "Title deed";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static NO_OWNERS_SELECTED_MESSAGE = "Please select an owner to copy to applicant";
    static MULTIPLE_OWNERS_SELECTED_MESSAGE = "Multiple owners have been selected, please select only one to copy to applicant";
    static COPY_OWNER_TO_APPLICANT_SUCCESS_MESSAGE = "Owner successfully copied to applicant";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static INVALID_ZONING_ATTRIBUTE = "Zoning attribute is missing on the property zoning layer. Please contact your systems administrator.";
    static ZONING_NOT_FOUND = "The found zone ({0}) has not been configured in the lookups. Please contact your systems administrator.";
    static LAYER_REF = "Town planning graphics";
    static PREVIOUS_REFERENCE_NUMBER_LABEL = "Previous reference number";
    static IS_RESUBMISSION_LABEL = "Is this application a resubmission?";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME = "previousReferenceNumber";
    static IS_RESUBMISSION_FORM_CONTROL_NAME = "isResubmission";
    static VERIFY_LABEL = "Verify";
    static ACCEPT_FORM_CONTROL_NAME = "acceptControl";
    static ACCEPT_RESUBMISSION_VERIFICATION_MESSAGE = "Please verify the previous application reference number first.";
    static RESUBMISSION_VERIFICATION_MESSAGE = "Reference number verification successful";
    static RESUBMISSION_VERIFICATION_MESSAGE_FAILURE = "Reference number verification unsuccessful";
    static RESUBMISSION_MESSAGE = "Location cannot be changed for applications marked as resubmission";
    static ACCEPT_LABEL = "I accept";
    static RESUBMISSION_DISCLAIMER_TITLE_LABEL_MESSAGE = "Resubmission Disclaimer title not configured, please contact your system administrator";
    static RESUBMISSION_DISCLAIMER_CONTENT_LABEL_MESSAGE = "Resubmission Disclaimer content not configured, please contact your system administrator";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        buildingUse: {
            required: `Building use ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        buildingFloorArea: {
            required: `Building floor area ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        titleDeed: {
            required: `Title deed ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zone: {
            required: `Zone ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        isResubmission: {
            required: `Is resubmission ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        previousReferenceNumber: {
            required: `Previous reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
